import { TranslateService } from '@ngx-translate/core';

// Textos de la renovación del KYC (FUN-1032). Las claves hay que crearlas en SimpleLocalize; mientras no existan
// se usa el texto por defecto en español
const DEFAULT_TEXTS: { [key: string]: string } = {
  'KYC_RENEWAL.BANNER_UPCOMING': 'Por normativa, tienes que renovar tu verificación de identidad antes del <strong>{{date}}</strong>. Solo te llevará un par de minutos.',
  'KYC_RENEWAL.BANNER_EXPIRED': 'Tu verificación de identidad ha caducado. Renuévala para volver a invertir, ingresar y retirar dinero.',
  'KYC_RENEWAL.BTN': 'Renovar verificación',
  'KYC_RENEWAL.MODAL_TXT': 'Por normativa, cada cierto tiempo tenemos que volver a verificar tu identidad. Ten a mano tu documento de identidad: te pediremos una foto y un selfie. La verificación de Mangopay se abre en inglés: puedes cambiar a español en el selector de idioma de arriba a la derecha.',
  'KYC_RENEWAL.REVIEW': 'Gracias, estamos revisando tu verificación. En unos minutos podrás volver a operar con normalidad.',
};

export function kycRenewalText(translate: TranslateService, key: string, params?: object): string {
  const text = translate.instant(key, params);
  if (text && text !== key) {
    return text;
  }
  let fallback = DEFAULT_TEXTS[key] || key;
  Object.entries(params || {}).forEach(([name, value]) => {
    fallback = fallback.replace(`{{${name}}}`, String(value));
  });
  return fallback;
}
